import { render, staticRenderFns } from "./CornerIconRibbon.vue?vue&type=template&id=5c2e1968&scoped=true&"
import script from "./CornerIconRibbon.vue?vue&type=script&lang=js&"
export * from "./CornerIconRibbon.vue?vue&type=script&lang=js&"
import style0 from "./CornerIconRibbon.vue?vue&type=style&index=0&id=5c2e1968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../frontend-internal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2e1968",
  null
  
)

export default component.exports